import React from 'react';
import { SelectItem } from './ui/select';

export const permissionSelectContentClassName =
  'z-[2100] w-[var(--radix-select-trigger-width)] max-w-[calc(100vw-2rem)]';

interface PermissionSelectItemProps {
  value: string;
  label: string;
  description: string;
}

export const PermissionSelectItem: React.FC<PermissionSelectItemProps> = ({
  value,
  label,
  description,
}) => (
  <SelectItem
    value={value}
    textValue={label}
    className="h-auto items-start whitespace-normal py-2"
  >
    <span className="flex min-w-0 flex-col gap-0.5 pr-2">
      <span>{label}</span>
      <span className="text-xs text-muted-foreground">{description}</span>
    </span>
  </SelectItem>
);
